import React from "react";

const Dashboard = () => {
  return (
    <div className="space-y-6">

      {/* Page Title */}
      <div>
        <h1 className="text-2xl font-bold text-slate-800">
          Dashboard
        </h1>
        <p className="text-slate-500 text-sm">
          Welcome to Work Management System
        </p>
      </div>

      {/* Summary Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">

        {/* Clients */}
        <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-200 hover:shadow-md transition">
          <p className="text-sm text-slate-500">Total Clients</p>
          <h2 className="text-2xl font-bold text-slate-800 mt-2">
            0
          </h2>
        </div>

        {/* Tasks */}
        <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-200 hover:shadow-md transition">
          <p className="text-sm text-slate-500">Active Tasks</p>
          <h2 className="text-2xl font-bold text-slate-800 mt-2">
            0
          </h2>
        </div>

        {/* Pending Approvals */}
        <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-200 hover:shadow-md transition">
          <p className="text-sm text-slate-500">Pending Approvals</p>
          <h2 className="text-2xl font-bold text-slate-800 mt-2">
            0
          </h2>
        </div>

        {/* Users */}
        <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-200 hover:shadow-md transition">
          <p className="text-sm text-slate-500">Total Users</p>
          <h2 className="text-2xl font-bold text-slate-800 mt-2">
            0
          </h2>
        </div>

      </div>

      {/* Activity Section */}
      <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-6">
        <h3 className="text-lg font-semibold text-slate-800 mb-4">
          Recent Activity
        </h3>

        <p className="text-sm text-slate-500">
          No recent activity available.
        </p>
      </div>

    </div>
  );
};

export default Dashboard;
